module.exports = __webpack_public_path__ + "static/media/Crown.691dedc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bagdes/Crown.png
// module id = 294
// module chunks = 0